import { gql, useQuery } from '@apollo/client';
import { useGeneralSoContext } from 'src/common/context';
import { useEffect, useState } from 'react';
import { GetSoQuery } from '../types/types';

const GET_SO_QUERY = gql(`
  query GetSo($id: String!) {
    getSo(id: $id) {
    _id
    soNumber
    status
    source
    email
    phoneNumber
    fullName
    productTypeId {
      code
      name
    }
    funnel {
      steps {
        code
        openedAt
      }
      latestStep
    }
    productTypeSpecific {
        travelData {
          insuranceType
          insuranceStartDate
          insuranceEndDate
          travelDestination
          insuranceRange
          sportActivities
          willWorkOnTrip
          numOfInsuredPersons
          numOfInsuredChildren
          numOfInsuredAdults
          allInsuredPersonsAreFromTheSameFamily
          tripValue
          luggageValue
          longestTripDuration
          longestTripDurationDays
          sportActivityCode
        }
        contractor {
          firstName
          lastName
          birthDate
          oib
          city
          cityKompareId
          street
          streetKompareId
          zipCode
          houseNumber
          email
          contractorIsPassenger
        }
        insuredPersons {
          firstName
          lastName
          birthDate
          oib
        }
    }
}
  }
`);

export function useGetSo() {
  const { soId } = useGeneralSoContext();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  const { data, loading, error, refetch } = useQuery<GetSoQuery>(GET_SO_QUERY, {
    variables: { id: soId },
    skip: !soId
  });

  const isLoading = !isInitialized || loading;

  return {
    so: soId ? data?.getSo : undefined,
    loading: isLoading,
    error,
    refetch,
    soId
  };
}
